import { AssistantTodoItem } from '@dreamai/types';

/**
 * Artifact types that are NOT shown in the "Waiting for You" section of the
 * Activity page (they are filtered out of the pending artifacts list).
 */
const ARTIFACT_TYPES_HIDDEN_FROM_WAITING = [
  'information_dump',
  'suggestion',
  'blank_todo',
];

/**
 * A sub-thread that is waiting on the user AND has a pending artifact visible
 * in the "Waiting for You" section is already represented there — it should be
 * hidden from the In-flight list (and excluded from activity counts) to avoid
 * double counting.
 */
export const isRepresentedInWaitingForYou = (
  todo: AssistantTodoItem,
): boolean => {
  if (todo.status !== 'waiting_on_user') return false;
  const artifact = todo.latestArtifact;
  if (!artifact) return false;
  if (artifact.status !== 'pending') return false;
  if (ARTIFACT_TYPES_HIDDEN_FROM_WAITING.includes(artifact.artifactType)) {
    return false;
  }
  return true;
};
